import type {Participant, ParticipantID} from '@pexip/infinity';

import {FuzzySearcher} from './fuzzySearcher';

/**
 * Fuzzy searcher for participants, matching on overlay text or display name.
 *
 * @example
 * const results = participantSearcher.search(participants, 'Alice');
 */
export const participantSearcher = new FuzzySearcher<
    Participant,
    ParticipantID
>({
    getKey: item => item.uuid,
    getSearchTexts: item => [item.overlayText ?? item.displayName ?? ''],
});
